import React from 'react';
import { RiFireFill, RiFireLine } from 'react-icons/ri';
import { isStudiedToday, isStreakAlive } from '../../utils/streak';

/* Header streak indicator.
   Three states, readable at a glance:
     · done today  — lit flame, orange, glowing
     · alive but not studied today — hollow flame, dimmed (a nudge)
     · no streak   — hollow flame, muted grey                       */
export default function StreakPill({ streak = 0, lastStudied, onClick }) {
  const done  = isStudiedToday(lastStudied);
  const alive = isStreakAlive(lastStudied) && streak > 0;
  const state = done ? 'done' : alive ? 'pending' : 'none';

  const title = done
    ? `${streak}-day streak — today is done`
    : alive
      ? `${streak}-day streak — study today to keep it`
      : 'No streak yet — study today to start one';

  return (
    <button
      type="button"
      className={`streak-pill ${state}`}
      onClick={onClick}
      title={title}
      aria-label={title}
    >
      {done ? <RiFireFill size={17} /> : <RiFireLine size={17} />}
      <span>{streak}</span>
    </button>
  );
}
